exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,html{min-height:100vh;width:100%;margin:0}.noMargin{margin:0}.noPadding{padding:0}", ""]);

// exports
exports.locals = {
	"noMargin": "noMargin",
	"noPadding": "noPadding"
};